import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import useScreenSize from '../../core/hooks/useScreenSize';
import { Icon } from '../common/Icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  StyledContainer,
  StyledSlide,
  StyledCloseButton,
  StyledImage,
} from './FullscreenSlider.styles';

function FullscreenSlider({ slides, clickedId, closeFullscreen }) {
  if (!slides) return null;

  const [size] = useScreenSize();
  const desktopWidth = useMemo(() => size > 991, [size]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <StyledContainer>
      <Swiper initialSlide={clickedId - 1} slidesPerView="1">
        {slides.map(slide => (
          <SwiperSlide key={slide.id}>
            {desktopWidth ? (
              <StyledImage src={slide.url || ''} />
            ) : (
              <StyledSlide backgroundUrl={slide.url ? slide.url : ''} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      <StyledCloseButton onClick={() => closeFullscreen()}>
        <Icon.Close aria-hidden />
      </StyledCloseButton>
    </StyledContainer>
  );
}

FullscreenSlider.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      alt: PropTypes.string,
      url: PropTypes.string.isRequired,
    })
  ),
  clickedId: PropTypes.number.isRequired,
};

export default FullscreenSlider;
